import axios from "../../../../../utils/authAxios";

const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/OfficeAppliancesTypeConfig";

export const getTypes = async () => {
  const { data } = await axios.get(`${api_base_url}/GetTypes`);
  return data;
};
